import { Component, computed, inject, input, ViewChild } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { Report } from '@modules/report/models/report.model';
import {
  HsDateTimePickerModule,
  HsFormFieldModule,
  HsIconModule,
  HsInputModule,
} from '@hsetu/ngui-components';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { HsLayerModule } from '@hsetu/ngui-resources';
import { ICON_FILE } from '@shared/ui/icons/icon-constants';
import { ReportService } from '@modules/report/services/report.service';
import { KfmCardComponent } from '@shared/ui/components/features/card/common/kfm-card.component';
import {
  DATE_LABEL,
  LOCATION_LABEL,
  REPORT_LABEL,
} from '@modules/report/i18n/label-text-constants';

@Component({
  selector: 'kfm-report-card',
  imports: [
    CommonModule,
    HsFormFieldModule,
    HsLayerModule,
    HsInputModule,
    HsIconModule,
    HsDateTimePickerModule,
    KfmCardComponent,
  ],
  templateUrl: './kfm-report-card.component.html',
})
export class KfmReportCardComponent {
  private readonly _datePipe = new DatePipe('de-DE');
  private readonly _sanitizer = inject(DomSanitizer);
  private readonly _reportService = inject(ReportService);

  protected readonly reportLabel = REPORT_LABEL;
  protected readonly dateLabel = DATE_LABEL;
  protected readonly locationLabel = LOCATION_LABEL;

  protected readonly cardIcon = computed<SafeHtml>(() =>
    this._sanitizer.bypassSecurityTrustHtml(ICON_FILE),
  );

  protected readonly longDesc = computed<string>(() => {
    const report = this.report();

    return report ? report.longDesc || '' : '';
  });

  protected readonly signDate = computed<Date>(() => {
    const report = this.report();

    if (report && report.signDate) {
      return new Date(report.signDate);
    }

    return new Date();
  });

  protected readonly location = computed<string>(() => {
    const report = this.report();
    return report ? report.signLocation || '' : '';
  });

  public report = input.required<Report>();
  public readonly isEditable = input<boolean>(true);

  /** EVENTS */

  protected onLongDescChanged(longDesc: string) {
    const report = this.report();

    if (report.longDesc !== longDesc) {
      report.longDesc = longDesc;

      this._reportService.update(report);
    }
  }

  protected onDateChanged(date: string) {
    const report = this.report();

    const signDate: string | null = this._datePipe.transform(
      new Date(date),
      'yyyy-MM-dd',
    );
    report.signDate = signDate ? signDate : '';

    this._reportService.update(report);
  }

  protected onLocationChanged(location: string) {
    const report = this.report();

    if (report.signLocation !== location) {
      report.signLocation = location;

      this._reportService.update(report);
    }
  }

  /*********** */
}
